import React, { useState, useEffect } from 'react';

export default props=>{
  const [display, setDisplay] = useState(props.display ||'inline');


  return (<div className="button" style={{display: display}}>
    <style jsx>{`

.button {
    display:inline;
    height: 24px;
    margin: 5px;
    border-radius: 16px;
    border: solid 1px #adb5bd;
    padding: 2px 10px 4px;
}

.text, .text a {
    display:inline;
    font-family: NotoSansCJKkr;
    font-size: 14px;
    color: white;
}


span{
  color: white;
}

`}</style>

    <div className="text">
      <span>{props.tag}</span>
      <span className="">&nbsp;</span>
      <a onClick={props.remove} >
        <img src="/assets/images/ico-close.svg" />
      </a>
    </div>

  </div>);
}